sessionStorage.removeItem('navidiumProductVariants')
function useConsole(...rest) {
  if (sessionStorage.getItem("NVD_DEV")) {
    console.log(
      '%c Navidium App:',
      'color: #00a0e9; font-weight: bold;',
      ...rest
    )
  }
}
const nvdStyles = document.createElement('style')
nvdStyles.innerHTML=`
.nvd-cta-loader {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid #fff;
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}
.nvd-cta-loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border-bottom: 4px solid #000000;
  border-left: 4px solid transparent;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`
document.head.appendChild(nvdStyles)
function nvdFindClosest(arr, target, adjustment = 'rounding_down') {
  if (!arr || !arr.length) return null
  let toMatch = parseFloat(target)
  let finalOutput = 0.0
  let n = arr.length
  for (let i = 0; i < n; i++) {
    let current = arr[i]
    let next = arr[i + 1]
    if (toMatch >= current && toMatch <= next) {
      if (adjustment === 'rounding_down') finalOutput = current
      if (adjustment === 'rounding_up') finalOutput = next
      break
    } else if (toMatch <= current) {
      finalOutput = current
      break
    }
  }
  return finalOutput
}
async function removeNavidium(variantId) {
  try {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }

    if (variantId) {
      return await fetch('/cart/change.js', {
        method: 'POST',
        headers,
        body: JSON.stringify({ id: String(variantId), quantity: 0 })
      })
    }

    const res = await fetch(`/cart.js?t=${Date.now()}`, {cache: 'no-cache'})
    const cart = await res.json()

    const itemsToRemove = cart.items.filter((item) =>
      item?.handle?.includes('shipping-protection') || item?.handle?.includes('navidium') ||
      nvdWidgetHelpers.product_handle?.includes(item.handle)
    
    )

    if (itemsToRemove.length === 0) return
    const updates = {}
    itemsToRemove.forEach((item) => {
      updates[item.id] = 0
    })
    
    await fetch('/cart/update.js', {
          method: 'POST',
          headers,
          body: JSON.stringify({ updates})
    })
    // for merchant who don't want to reload the page
    if (!window.navadiumStopReload) {
      location.reload()
    }
  } catch (error) {
    useConsole('ERROR Removing NVD', error)
  }
}

const getNavidiumMarketPrice = async (apiVariant) => {
  try {
    // Check if data is already in sessionStorage
    const sessionKey = 'navidiumProductVariants'
    const cachedData = sessionStorage.getItem(sessionKey)

    if (cachedData) {
      const productVariants = JSON.parse(cachedData)
      return productVariants[String(apiVariant)]
    }

    // If not in sessionStorage, call the API
    const handles = nvdWidgetHelpers?.product_handle?.split(',') || [
      'navidium-shipping-protection'
    ]
    const allProductVariants = await Promise.all(
      handles.map(async (handle) => {
        const response = await fetch(`/products/${handle}.js`)
        const product = await response.json()
        return product.variants
      })
    )

    // Flatten and process the data
    const variants = allProductVariants.flat()
    const productVariants = {}
    variants.forEach((variant) => {
      const variantID = String(variant.id)
      productVariants[variantID] = variant.price
    })

    // Save the data to sessionStorage
    sessionStorage.setItem(sessionKey, JSON.stringify(productVariants))

    // Return the price for the requested variant
    return productVariants[String(apiVariant)]
  } catch (error) {
    console.error('Error fetching Navidium Market Price:', error)
  }
}
// initially fetching product data
getNavidiumMarketPrice()
const nvdLocationFinder = location.pathname

if (
  nvdLocationFinder === '/account/login' ||
  nvdLocationFinder === '/account/register' || window.keepNavidium
) {
  useConsole('Navidium Exist')
} else {
  removeNavidium()
}

function nvdFormatMoney(cents) {
 try {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '')
  }
  let value = ''
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
  const formatString = nvdShopCurrency

  function defaultOption(opt, def) {
    return typeof opt === 'undefined' ? def : opt
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2)
    thousands = defaultOption(thousands, ',')
    decimal = defaultOption(decimal, '.')

    if (isNaN(number) || number == null) {
      return 0
    }
    number = (number / 100.0).toFixed(precision)
    const parts = number.split('.')
    const dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    )
    const cents = parts[1] ? decimal + parts[1] : ''

    return dollars + cents
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2)
      break
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0)
      break
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',')
      break
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',')
      break
    default:
      value = formatWithDelimiters(cents, 2)
      break
  }

  return formatString.replace(placeholderRegex, value)
 } catch (error) {
    const currency = Shopify?.currency?.active || 'USD'
    const formattedAmount = new Intl.NumberFormat(Shopify?.locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'narrowSymbol'
    }).format(cents / 100)
    return formattedAmount
 }
}
const getNvdConfig = async () => {
  try {
    if (nvdWidgetConfig) return nvdWidgetConfig
    const response = await fetch(
      `https://d10pwglna6up6p.cloudfront.net/navidium-widgets/json-files/${nvdShop}.json`
    )
    if (response.status == 200) {
      return await response.json()
    } else {
      const response = await fetch(
        `https://navidium-static-assets.s3.amazonaws.com/navidium-widgets/json-files/${nvdShop}.json`
      )
      return await response.json()
    }
  } catch (error) {
    return {}
  }
}
const getNvdVisitorCountry = async () => {
  const fallbackUrl = 'https://geoip.apps.getjoy.ai/geo.json'

  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const response = await fetch(
      `https://5oy2nnjxatw6egeqhkwdcm76um0vvdig.lambda-url.us-east-1.on.aws/?timezone=${timezone}`,
      { signal: AbortSignal.timeout(2500) }
    )
    if (response.ok) {
      return await response.json()
    }
  } catch (_) {
    // ignore and fall back
  }

  try {
    const fallbackResponse = await fetch(fallbackUrl, {
      signal: AbortSignal.timeout(2000),
    })
    const data= await fallbackResponse.json()
      return {country_name:data.country}
  } catch (error) {
    console.error('Both API calls failed:', error)
    return {}
  }
}
const nvdPrefetch = async (callback) => {
  // Save visitor country

  // TODO: check nvd_config in sessionStorage
  let nvdConfig = sessionStorage.getItem('nvdconfig')
    ? JSON.parse(sessionStorage.getItem('nvdconfig'))
    : null
  // verify with the shop name
  if (nvdConfig) {
    // check expiration
    useConsole('Navidium config avaialable in storage')
    return nvdConfig
  } else {
    useConsole('Navidium config not available in storage')
    try {
      const country = await getNvdVisitorCountry()
      if(country?.country_name) sessionStorage.setItem('nvdVisitorCountry', country?.country_name)
      const nvdConfig = await getNvdConfig()
      useConsole(nvdConfig)
      const disclaimer_properties = nvdConfig?.disclaimer_properties
      if (disclaimer_properties)
        sessionStorage.setItem('nvdDisclaimer', disclaimer_properties)
      const today = new Date()
      const shopConfig = {
        nvd_static_rules: nvdConfig.nvd_static_rules?.sort((a,b)=>a?.from-b?.from),
        success: nvdConfig.success,
        show_on_cart: nvdConfig.nvd_show_cart,

        auto_insurance: nvdConfig.nvd_auto_insurance,
        nvd_name: nvdConfig.nvd_name,
        nvd_subtitle: nvdConfig.nvd_subtitle,
        widget_icon: nvdConfig.nvd_widget_icon,
        opt_out_icon:
          nvdConfig.nvd_widget_icon_alt || nvdConfig.nvd_widget_icon,
        learnMore: nvdConfig?.nvd_learn_more,
        nvd_description: nvdConfig.nvd_description,
        nvd_message: nvdConfig.nvd_message,
        protection_variants: nvdConfig.nvd_variants,
        product_exclusion: nvdConfig.product_exclusion,
        min_protection_price: nvdConfig.min_protection_value,
        max_protection_price: nvdConfig.max_protection_value,
        protection_type: nvdConfig.nvd_protection_type,
        protection_percentage: nvdConfig.nvd_protection_type_value,
        min_protection_variant: nvdConfig.min_variant_id,
        max_protection_variant: nvdConfig.max_variant_id,
        expiration: today.setDate(today.getDate() + 3),
        nvd_widget_style: nvdConfig.nvd_widget_style,
        previewMode: nvdConfig.nvd_preview_mode,
        rounding_value: nvdConfig.rounding_value,
        maxThreshold: nvdConfig.threshold_value,
        nvd_widget_template: nvdConfig.nvd_widget_template,
        exclusion_action: nvdConfig?.exclusion_action,
        nvd_international: nvdConfig.nvd_international,
        nvd_international_fee: nvdConfig.nvd_international_fee,
        nvd_international_fee_active: nvdConfig.nvd_international_fee_active,
        nvd_nations: isValidJSON(nvdConfig?.nvd_nations)
          ? JSON.parse(nvdConfig.nvd_nations)
          : []
      }

      sessionStorage.setItem('nvdconfig', JSON.stringify(shopConfig))
      if (callback) return callback()
    } catch (error) {
      useConsole(
        '%c navidium error fetching config',
        'color: yellow; background-color: red; font-size: 12px',
        error
      )
    }
  }
}
const calculateNvdCustomFee = (
  custom_setting_operator,
  custom_setting_price,
  convertedTotalInStoreCurrency) => {

  if (custom_setting_operator === 'is_greater_than' && convertedTotalInStoreCurrency > custom_setting_price) {
    return true

  } else if (custom_setting_operator === 'is_less_than' && convertedTotalInStoreCurrency < custom_setting_price) {
    return true
  }
  return false
}
function nvdRoundUp(number) {
  return Math.floor(number * 100) / 100
}
const nvdCalculateProtection = async (cartTotal, nvdConfig) => {
  let conversionRate = parseFloat(Shopify.currency.rate)
  let convertedTotal = cartTotal / conversionRate
  let protection_type = nvdConfig.protection_type
  let protection_percentage = nvdConfig.protection_percentage
  let protectionId
  let protectionPrice
  let minPrice = Number(nvdConfig.min_protection_price)
  let maxPrice = Number(nvdConfig.max_protection_price)
  let minId = nvdConfig.min_protection_variant
  let maxId = nvdConfig.max_protection_variant
  let protectionVariants = nvdConfig.protection_variants
  let PriceRounding = nvdConfig.rounding_value
  const nvdInternationalFeeActive = nvdConfig?.nvd_international_fee_active
  const nvdInternationalFee = nvdConfig?.nvd_international_fee
  protection_type = parseInt(protection_type)
  let { custom_setting_fee,
    custom_setting_operator,
    custom_setting_price,
    is_custom_setting} = nvdWidgetConfig
  useConsole('113 protection_type', protection_type)

  const nvdVisitorCountry = sessionStorage.getItem('nvdVisitorCountry')
  const nvd_nations = nvdConfig.nvd_nations?.map((country) => country.name)
  useConsole(nvd_nations)
  if (!nvd_nations?.includes(nvdVisitorCountry)) {
    if (nvdInternationalFeeActive == 1) {
      protection_percentage = nvdInternationalFee
      useConsole(
        'International fee is activated, International fee percentage is',
        protection_percentage
      )
    }
  }
  const isCustomFeeRequired = is_custom_setting ? calculateNvdCustomFee(custom_setting_operator, custom_setting_price, convertedTotal) : false

  if(isCustomFeeRequired) protection_percentage = custom_setting_fee

  // TODO: check protection type
  if (protection_type == 1 || isCustomFeeRequired) {
    // protection is dynamic
    let ourProtectionPrice = (convertedTotal * protection_percentage) / 100
    ourProtectionPrice = nvdRoundUp(ourProtectionPrice)
useConsole({ourProtectionPrice})
    // calculate the protection
    if (ourProtectionPrice < minPrice) {
      useConsole('Our protection price is less than minimum')
      protectionPrice = minPrice
      protectionId = minId
      return {
        price: protectionPrice,
        variant_id: protectionId
      }
    } else if (ourProtectionPrice > maxPrice) {
      useConsole('Our protection price is greater than maximum')
      protectionPrice = maxPrice
      protectionId = maxId
      return {
        price: protectionPrice,
        variant_id: protectionId
      }
    } else {
      useConsole('calculating protection')

      const priceArray = Object.keys(protectionVariants)
      priceArray.sort((a, b) => a - b)
      if (nvdWidgetConfig?.nvd_single_variant === '1') {
        useConsole('Single variant mode enabled')
        protectionPrice = ourProtectionPrice
        protectionId = minId
      }else{
        protectionPrice = nvdFindClosest(
        priceArray,
        ourProtectionPrice,
        PriceRounding
      )
      }
      if (protectionPrice == 0) {
        return {
          price: maxPrice,
          variant_id: maxId
        }
      }
      protectionId = protectionVariants[protectionPrice] ||minId
      useConsole({
        price: protectionPrice,
        variant_id: protectionId
      })
      return {
        price: protectionPrice,
        variant_id: protectionId
      }
    }
  } else {
    useConsole('protection is static')
    const nvd_static_rules = nvdConfig.nvd_static_rules
    if (nvd_static_rules.length) {
      for (let i = 0; i < nvd_static_rules.length; i++) {
        let from = nvd_static_rules[i]['from']
        let to = nvd_static_rules[i]['to']
        if(convertedTotal < from){
          useConsole("Cart total is less than minimum static amount, widget hidden")
          return null
        }
        let next_from = null
        if (nvd_static_rules[i + 1]) {
          next_from = nvd_static_rules[i + 1]['from']
        }
        protectionId = nvd_static_rules[0]['id']
        protectionPrice = nvd_static_rules[0]['price']
        if (next_from && convertedTotal < from && convertedTotal < next_from) {
          protectionId = nvd_static_rules[i]['id']
          protectionPrice = nvd_static_rules[i]['price']
        } else if (convertedTotal > to && !next_from) {
          protectionId = nvd_static_rules[i]['id']
          protectionPrice = nvd_static_rules[i]['price']
        }
        if (from <= convertedTotal && convertedTotal <= to) {
          protectionId = nvd_static_rules[i]['id']
          protectionPrice = nvd_static_rules[i]['price']
          break
        }
      }
      return {
        price: protectionPrice,
        variant_id: protectionId
      }
    }
  }
}

const nvd_init = async () => {
  if(window.hideNavidium){
    console.log('Navidium is hidden for window.hideNavidium, skipping initialization')
    return
  }
  if (window.needToInjectNvd) {
    injectNvdToCart()
  }
  // console.time('nvd_init')
  localStorage.setItem('nvd_running', true)
  const shopConfig = sessionStorage.getItem('nvdconfig')
    ? JSON.parse(sessionStorage.getItem('nvdconfig'))
    : null
  if (shopConfig) {
    useConsole('Navidium config avaialable in storage')
  } else {
    useConsole('Navidium config not avaialable in storage. nvdPrefetching now')
    await nvdPrefetch(nvd_init)
    return
  }
  const cartProtectionVariant = localStorage.getItem('cart_protection')

  const isAgree = JSON.parse(sessionStorage.getItem('nvdAgree'))
  let showWidget = true

  const exclusionAction = shopConfig?.exclusion_action

  if (exclusionAction == '0') {
    const excluded = isValidJSON(shopConfig.product_exclusion)
      ? JSON.parse(shopConfig.product_exclusion)
      : {}
    const cart = await getNvdCartCallback()

    cart?.items?.forEach((item) => {
      excluded?.sku?.forEach((sku) => {
        if (item.sku === sku) {
          showWidget = false
          useConsole('Excluded product in cart, Widget hidden')
        }
      })
      excluded?.types?.forEach((type) => {
        if (item.product_type === type) {
          showWidget = false
          useConsole('Excluded product in cart, Widget hidden')
        }
      })
    })
    if(excluded?.collections?.length > 0 && window.nvdCartItems?.length > 0){
      window.nvdCartItems?.forEach((item) => {
        
        excluded?.collections?.forEach((collection) => {
          console.log({item,collection});
          if (item?.collections?.includes(collection)) {
            showWidget = false
            useConsole('Excluded product in cart, Widget hidden')
          }
        })
      })
    }
  }

  const nvd_nations = shopConfig.nvd_nations?.map((country) => country?.name) || []
  const nvdVisitorCountry = sessionStorage.getItem('nvdVisitorCountry') === 'undefined' || !sessionStorage.getItem('nvdVisitorCountry') ? nvd_nations[0]: sessionStorage.getItem('nvdVisitorCountry')
  const nvdInternationalActive = shopConfig.nvd_international
  if (nvdInternationalActive == 0) {
    if (!nvd_nations?.includes(nvdVisitorCountry)) {
      showWidget = false
      useConsole('Widget is disabled for international')
    }
  }

  if (shopConfig.show_on_cart === '0') showWidget = false

  useConsole('showWidget', showWidget)

  const { success } = shopConfig

  let checked

  useConsole('in cart protection variant', cartProtectionVariant)
  // check if widget should be shown and limit did not exceeded
  if (showWidget && success) {
    const cart = await getNvdCartCallback(nvdCheckCart)
    const cartTotal = (await cart.total) / 100
    // Displays the originalCartTotal in the standard widget. cartTotal is used to calculate the protection price and may be lower than originalCartTotal since it excludes certain product prices, such as gift cards , digital products also some selected product in dashboard.
    const originalCartTotal = (await cart.originalCartTotal) / 100
    useConsole('after exclusion total price is', cartTotal)
    const getProtection = await nvdCalculateProtection(cartTotal, shopConfig)
    if(!getProtection){
      useConsole("No variant found, widget hidden")
      return 
    }
    useConsole({ getProtection })
    const variantFromApi = await getProtection.variant_id
    const priceFromApi = await getProtection.price
    const marketPrice = await getNavidiumMarketPrice(variantFromApi)
    const protectionPrice = marketPrice
      ? marketPrice
      : priceFromApi * 100 * Shopify?.currency?.rate || 1

    // Max threshold
    let maxThresholdPrice = parseFloat(shopConfig.maxThreshold)
    maxThresholdPrice = (
      maxThresholdPrice * parseFloat(Shopify.currency.rate)
    ).toFixed(2)
    //useConsole('%cNVD Max threshold','background:red;color:#fff;padding:0 3px;',maxThresholdPrice);
    // End of max threshold
    const cartEmpty = cartTotal <= 0

    // now we get the cart total price and time to hit the second api
    localStorage.setItem('nvdProtectionPrice', protectionPrice)
    localStorage.setItem('nvdVariant', variantFromApi)

    if (cartEmpty || maxThresholdPrice <= cartTotal) {
      document
        .querySelectorAll('.nvd-mini')
        .forEach((item) => (item.innerHTML = ''))
      document
        .querySelectorAll(nvdWidgetHelpers?.checkout_section)
        .forEach((elm) => (elm.style.display = ''))
      useConsole(
        'cart total is zero or max threshold true. No need to add protection'
      )
      return
    }

    if (isAgree) {
      checked = true
    } else {
      checked = false
    }
    useConsole({ isAgree })

    useConsole('widget check status: ', checked)
    nvdVariant = variantFromApi
    const storeAgreeCheckbox = window.nvdStoreCheckbox
      ? document.querySelector(window.nvdStoreCheckbox)
      : null
    // build widget theme
    let widgetContent
    if (!isAgree) {
      widgetContent = buildStandardTemplate(
        protectionPrice,
        originalCartTotal,
        storeAgreeCheckbox
      )
    } else {
      widgetContent = buildClassicWidget(protectionPrice, checked)
    }
    // now check the variant in cart is equal to the variant in api return
    if (cartProtectionVariant) {
      if (cartProtectionVariant === variantFromApi) {
        useConsole(
          '1. cart variant is same as the api variant,stay idle and build widget',
          cartProtectionVariant,
          variantFromApi
        )
        nvdVariant = cartProtectionVariant
        if (document.querySelector('.nvd-mini')) {
          document.querySelectorAll('.nvd-mini').forEach((item) => {
            item.innerHTML = widgetContent
          })
        }
      } else {
        useConsole('cart variant and api variant is not same.swapping them now')
        nvdVariant = variantFromApi

        // now append the snippet
        if (document.querySelector('.nvd-mini')) {
          document.querySelectorAll('.nvd-mini').forEach((item) => {
            item.innerHTML = widgetContent
          })
        }
      }
    } else if (checked) {
      useConsole(
        'Protection Not available. Adding now.',
        cartProtectionVariant,
        variantFromApi
      )
      nvdVariant = variantFromApi
      if (document.querySelector('.nvd-mini')) {
        document.querySelectorAll('.nvd-mini').forEach((item) => {
          item.innerHTML = widgetContent
        })
      }
    } else {
      nvdVariant = variantFromApi
      useConsole('no protection available, just append snippet')
      if (document.querySelector('.nvd-mini')) {
        document.querySelectorAll('.nvd-mini').forEach((item) => {
          item.innerHTML = widgetContent
        })
      }
    }
  // hiding store checkout button
  const checkoutSections = nvdWidgetHelpers?.checkout_section
    ? document.querySelectorAll(nvdWidgetHelpers?.checkout_section)
    : []
  if (checkoutSections.length > 0 && document.querySelectorAll('.nvd-mini').length)
    checkoutSections.forEach((elm) => (elm.style.display = 'none'))
    // now
  } else {
    // when navidium widget is shut off
    if (document.querySelectorAll('.nvd-mini').length) {
      document
        .querySelectorAll('.nvd-mini')
        .forEach((elm) => (elm.innerHTML = ''))
    }
     document
        .querySelectorAll(nvdWidgetHelpers?.checkout_section)
        .forEach((elm) => (elm.style.display = ''))
    useConsole(
      '%c Navidium Message:widget is shut off.Please turn on from your app settings',
      'color: yellow; background-color: blue; font-size: 12px'
    )
  }
  // console.timeEnd('nvd_init')
  localStorage.setItem('nvd_running', false)
  nvdUpdateLiveCart()
}

// function to get cart data and pass the data to another callback for processing.
const getNvdCartCallback = async (callback) => {
  const cart = await fetch(`/cart.js?t=${Date.now()}`, {cache: 'no-cache'})
  const cartData = await cart.json()

  if (callback) return callback(cartData)

  return cartData
}
const isValidJSON = (data) => {
  try {
    JSON.parse(data)
    return true
  } catch (error) {
    return false
  }
}

// function to check cart items
const nvdCheckCart = async (cartData, callback = null) => {
  const currency = await cartData.currency
  useConsole('cart in check cart', cartData)
  if (cartData.items.length != 0) {
    const { items } = cartData
    let total = parseFloat(cartData.total_price)
    let originalCartTotal = cartData.total_price
    const nvdCounterArray = []
    let recheck = false
    let dupeVariant
    const shopConfig = sessionStorage.getItem('nvdconfig')
      ? JSON.parse(sessionStorage.getItem('nvdconfig'))
      : null

    const excluded = isValidJSON(shopConfig.product_exclusion)
      ? JSON.parse(shopConfig.product_exclusion)
      : {}

    // if no shop config is found wait and call nvdPrefetch
    if (!shopConfig) {
      await nvdPrefetch()
    }

    useConsole('product exclusion', excluded)
    items.forEach((item) => {
      // check for duplicate navidium
      if (item.handle.includes('shipping-protection') || nvdWidgetHelpers.product_handle?.includes(item.handle)) {
        nvdCounterArray.push(item.variant_id)

        useConsole('protection available in cart')

        localStorage.setItem('cart_protection', item.variant_id)

        total -= item.final_line_price
        originalCartTotal -= item.final_line_price

        useConsole('nvd1', total)
        if (item.quantity > 1) {
          useConsole('Found duplicate protection in cart,decreasing now')

          // as cart total is update. we need to call the nvdCheckCart function recursively
          recheck = true
          dupeVariant = item.variant_id
        } else {
          useConsole('protection duplication test passed')
        }
      } else {
        if (excluded?.length >= 0) {
          excluded?.forEach((sku) => {
            if (item.sku === sku) {
              if (shopConfig.exclusion_action == '0') {
                localStorage.setItem('exclusion_action', 'hide_widget')
              } else {
                useConsole(
                  '%c Navidium Message:Product is excluded',
                  'color: yellow; background-color: blue; font-size: 16px',
                  item.sku,
                  item.final_price
                )
                // substract the item price from total
                total -= item.final_line_price
                useConsole('ex1', total)
              }
            }
          })
        } else {
          excluded?.sku?.forEach((sku) => {
            if (item.sku === sku) {
              useConsole(
                '%c Navidium Message:Product is excluded',
                'color: yellow; background-color: blue; font-size: 16px',
                item.sku,
                item.final_price
              )
              // substract the item price from total
              total -= item.final_line_price
              useConsole('ex1', total)
            }
          })
          excluded?.types?.forEach((type) => {
            if (item.product_type === type) {
              useConsole(
                '%c Navidium Message:Product is excluded',
                'color: yellow; background-color: blue; font-size: 16px',
                item.sku,
                item.final_price
              )
              // substract the item price from total
              total -= item.final_line_price
              useConsole('ex1', total)
            }
          })
        }
      }
    })
    if(excluded?.collections?.length > 0 && window.nvdCartItems?.length > 0){
      window.nvdCartItems?.forEach((item) => {
        
        excluded?.collections?.forEach((collection) => {
          if (item?.collections?.includes(collection)) {
            total -= item.final_line_price
          }
        })
      })
    }    
    if (recheck === true) {
      const mutateCart = adjustProtectionQuantity(dupeVariant, 0, false)
      useConsole('calling nvdCheckCart function recursively', mutateCart)
      getNvdCartCallback(nvdCheckCart)
    }
    if (nvdCounterArray.length > 1) {
      useConsole(
        '%cfound more than one variant of navidium protection in cart,removing all now',
        'color:red'
      )
      nvdCounterArray.forEach((item) => {
        useConsole('removing variant', item)
        adjustProtectionQuantity(item, 0)
        localStorage.removeItem('cart_protection')
        recheck = false
      })
    }
    if (nvdCounterArray.length == 0) {
      useConsole('No protection available in cart')
      localStorage.removeItem('cart_protection')
    }
    if (nvdCounterArray.length == items.length) {
      useConsole('no items in cart rather than protection')
      fetch('/cart/clear.js').then((res) => {
        useConsole('cart cleared')
        if (!window.navadiumStopReload) {
          location.reload()
        }
        localStorage.removeItem('cart_protection')
      })
    }
    return {
      total: parseFloat(total),
      currency,
      originalCartTotal: originalCartTotal
    }
  }
  return {
    total: 0,
    currency
  }
}
const nvdRedirectToCheckout = () => {
try {
  const checkoutBtn = nvdWidgetHelpers?.store_checkout_button + ", [name='checkout']"
  if(window.nvdStopRedirect && document.querySelector(checkoutBtn)){
    document.querySelector(checkoutBtn).click()
  }else{
    location.href = '/checkout'
  }
} catch (error) {
  location.href = '/checkout'
}
}
// function to add protection to cart
const addProtection = async (variantId, quantity = 1, reload = false) => {
  const { status, property_name, property_value } =
    sessionStorage.getItem('nvdDisclaimer') &&
    isValidJSON(sessionStorage.getItem('nvdDisclaimer'))
      ? JSON.parse(sessionStorage.getItem('nvdDisclaimer'))
      : {}

  const properties = {}
  if (status) {
    properties[property_name] = property_value
  }
  const nvdStoreCredit = window.nvdStoreCredit

  if (nvdStoreCredit?.store_credit) {
    properties['_nvd_sc_type'] = nvdStoreCredit?.choose_credit_type
    properties['_nvd_sc_value'] = nvdStoreCredit?.amount
  }
  const isSingleVariant = nvdWidgetConfig?.nvd_single_variant === '1'
  const protectionPrice = localStorage.getItem('nvdProtectionPrice') /100
  if (isSingleVariant && protectionPrice) {
    properties['_nvd_protection_fee']= protectionPrice 
  }
  const request = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity,
      properties
    })
  }

  const cartData = await fetch('/cart/add.js', request)
  const cartJson = await cartData.json()
  if (cartJson.id) {
    localStorage.setItem('nvd_opted_out', false)
    localStorage.setItem('cart_protection', variantId)
    useConsole(
      '%c Protection added successfully',
      'color: white; background-color: green'
    )
  }
}

// function to update protection variant from cart
const adjustProtectionQuantity = async (
  variantId,
  quantity,
  reload = false
) => {
  const request = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json;',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      id: String(variantId),
      quantity: String(quantity)
    })
  }

  const cartData = await fetch('/cart/change.js', request)

  const cartJson = await cartData.json()

  useConsole(
    '%cnew cart instance after duplicate protection quantity decrease',
    'color:yellow',
    cartJson
  )
  console.dir(cartJson)
  nvdUpdateLiveCart(cartJson)
  if (reload) {
    location.reload()
  } else {
    return cartJson
  }
}

// widget switch on/off listener function
const getShippingProtection = async (e) => {
  const { checked } = e

  if (!checked) {
    useConsole('unchecking and removing protection')
    sessionStorage.setItem('nvdAgree', null)
    nvd_init()
    nvdUpdateLiveCart()
  } else {
    useConsole('checked and adding protection')
    sessionStorage.setItem('nvdAgree', true)
    nvd_init()
    nvdUpdateLiveCart()
  }
}
async function getNvdCartDetails(){
try {
  const res = await fetch('/cart?view=nvd-cart.json')
  const data = await res.json()
  return data
} catch (error) {
  return null
}
}
// function to update subtotal and dom cart item's line id
const nvdUpdateLiveCart = async (cartData = null) => {
  const isAgree = JSON.parse(sessionStorage.getItem('nvdAgree'))
  if (!isAgree) return
  let cart = cartData
  if (cart == null) cart = await getNvdCartCallback()
  let curRate = Shopify.currency.rate

  let cartTotal = cart.total_price
  const protectionPrice = Number(localStorage.getItem('nvdProtectionPrice'))
  useConsole('protection price-->>', protectionPrice)
  let totalPrice
  const cartItems = cart.items
  const totalCount = cart.item_count
  const optedOut = localStorage.getItem('nvd_opted_out')
    ? Boolean(JSON.parse(localStorage.getItem('nvd_opted_out')))
    : null

  const totalElem = document.querySelectorAll(
    nvdWidgetHelpers?.subtotal_element
  )

  let currentCount
  let XtotalPrice
  //  if not opted out show one less in count
  if (optedOut == false) {
    currentCount = totalCount
    XtotalPrice = cartTotal + protectionPrice
    totalPrice = nvdFormatMoney(XtotalPrice)
    useConsole('x total price', XtotalPrice)
  }
  if (optedOut == true || optedOut == null) {
    totalPrice = nvdFormatMoney(cart.total_price)
    currentCount = totalCount
    useConsole(' total price', totalPrice)
  }
  useConsole('updating subtotal', totalPrice)
  if (cart.item_count == 0) currentCount = 0
  useConsole('current and cart count', currentCount, totalCount)
  if (totalElem && document.querySelector('.nvd-mini')?.innerHTML)
    totalElem.forEach((elem) => (elem.innerHTML = totalPrice))
}

const isValidUrl = (urlString) => {
  const urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i'
  ) // validate fragment locator
  return !!urlPattern.test(urlString)
}
function buildClassicWidget(protectionPrice, checked) {
  const {
    id,
    section_content: { title, subtitle, img },
    section_style: {
      background_color,
      title_color,
      subtitle_color,
      icon_color,
      protection_amount_color
    }
  } = nvdConsentConfig.landing_popup.widget_settings

  return `
  <div style="width: 100%; max-width: 500px; background-color: ${background_color}; padding: 10px; margin: 10px auto; display: flex; flex-direction: column;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <div style="position: relative;top: 4px;">
          <input ${
            checked ? 'checked' : ''
          } onchange="getShippingProtection(this)" type="checkbox" id="shippingProtectionCheckBox" style="width: 16px; height: 16px; display: inline-block; cursor: pointer;">
        </div>
          <div style="display: flex; align-items: center; gap: 10px;">
            <h4 style="font-size: 16px; color: ${title_color}; margin: 0;">${title}</h4>
             <strong style="color: ${protection_amount_color}; font-size: 12px;">
              ${nvdFormatMoney(protectionPrice)}
            </strong>
          </div>
      </div>

      <div style="display: flex; align-items: start; justify-content: space-between; gap: 5px;">
     <p style="color: ${subtitle_color}; font-size: 12px; margin: 0;line-height: 18px;">
            ${subtitle}
          </p>
             ${
               img
                 ? ` <img 
              style="width: 70px; object-fit: contain;"
              src="${img}" 
            />`
                 : `<svg xmlns="http://www.w3.org/2000/svg" width="40" height="45" fill="${icon_color}" viewBox="0 0 55 65"><path fill="${icon_color}" d="m32.079 42.638 14.735-8.78v4.844L28.143 49.3V24.17l27.25-15.946V37.39s-.639 4.082-1.716 6.46c-1.056 2.33-1.97 3.505-3.633 5.45-2.217 2.592-3.952 3.578-6.661 5.651-5.578 4.268-15.341 9.386-15.341 9.386v-4.743s8.177-4.614 12.919-8.276c2.368-1.83 3.95-2.636 5.853-4.945 1.252-1.52 1.925-2.441 2.725-4.24.782-1.755 1.312-4.743 1.312-4.743V15.994L32.08 27.096v15.542Z"></path><path fill="${icon_color}" d="M28.041 64.334V59.59l-11.505-6.964s-4.458-2.775-6.661-5.248C8.52 45.86 7.859 44.904 6.847 43.14c-.887-1.544-1.475-2.412-1.918-4.137-.608-2.367 0-6.258 0-6.258L50.75 5.797l-4.743-2.523L.79 29.918s-.753 5.617 0 9.084c.538 2.474 1.098 3.837 2.321 6.055 1.264 2.292 2.235 3.452 4.038 5.35 2.28 2.4 6.66 5.247 6.66 5.247l14.231 8.68ZM32.889.652.896 19.525v5.248L41.468.653h-8.58ZM13.713.752.896 8.322v6.156L24.108.752H13.713Z"></path></svg>`
             }
      </div>
  </div>
  `
}
function buildStandardTemplate(protectionPrice, cartTotal, storeAgreeCheckbox) {
  const templateId = nvdConsentConfig?.standard_widget?.templateId
  switch (templateId) {
    case 1:
      return standardWidgetTemplateOne(
        protectionPrice,
        cartTotal,
        storeAgreeCheckbox
      )
    case 2:
      return standardWidgetTemplateTwo(
        protectionPrice,
        cartTotal,
        storeAgreeCheckbox
      )
    case 3:
      return standardWidgetTemplateThree(
        protectionPrice,
        cartTotal,
        storeAgreeCheckbox
      )
    case 4:
      return standardWidgetTemplateFour(
        protectionPrice,
        cartTotal,
        storeAgreeCheckbox
      )

    default:
      return standardWidgetTemplateOne(
        protectionPrice,
        cartTotal,
        storeAgreeCheckbox
      )
  }
}
function standardWidgetTemplateOne(
  protectionPrice,
  cartTotal,
  storeAgreeCheckbox
) {
  const {
    general: {
      section_content: { logo },
      section_style: {
        background_color,
        border_color,
        icon_color,
        icon_background_color,
        protection_amount_color
      }
    },
    heading: {
      section_content: {
        title,
        subtitle,
        learn_more,
        learn_more_text,
        learn_more_destination
      },
      section_style: {
        title_color,
        subtitle_color,
        learn_more_color,
        title_font_size,
        title_font_weight,
        subtitle_font_size,
        subtitle_font_weight
      }
    },
    cta_button: {
      section_content: {
        img,
        button_text,
        is_secondary_button_enable,
        secondary_button_text,
        show_subtotal,
        show_additional_checkout_button
      },
      section_style: {
        button_color,
        button_background_color,
        secondary_button_color,
        secondary_button_background_color,
        button_font_size,
        secondary_button_font_size,
        button_font_weight,
        secondary_button_font_weight,
      }
    }
  } = nvdConsentConfig?.standard_widget

  const cartSubTotal = cartTotal * 100
  const isDisabled = storeAgreeCheckbox && !storeAgreeCheckbox?.checked
  const totalWithProtection = cartSubTotal + protectionPrice
  const nvdTotal = nvdFormatMoney(totalWithProtection)
  const buttonLabel = button_text.replaceAll('{price}', nvdTotal)?.replaceAll('{protection_price}', nvdFormatMoney(protectionPrice))
  const secondaryButtonLabel = secondary_button_text?.replaceAll(
    '{price}',
    nvdFormatMoney(cartSubTotal)
  )

  return `
      <div class="nvd-standard-widget-t-one"  id="nvd-standard-widget-container" style="
        background-color: ${background_color};
        max-width: 375px;
        padding: 8px;
        border: 2px solid ${border_color};
        display: flex;
        gap:4px;
        flex-direction: column;
        justify-content: center;
      ">
      ${ show_subtotal ? 
        `<div class="nvd-subtotal-area" style="display:flex;justify-content:space-between;align-items:center">
            <p style="margin:0;">Subtotal:</p>
            <p class="nvd-subtotal-price" style="margin:0;">${nvdFormatMoney(cartSubTotal)}</p>
          </div>` : ''
      }
      <div class="nvd-main-content-area">
        <div id="nvd-standard-widget-contents"  style="
          display: flex;
          align-items: center;
          gap:10px;
        " class="nvd-widget-contents">
          <div id="nvd-standard-widget-logo" style="max-width: 60px; max-height:60px; background-color:${icon_background_color};padding:10px">
           ${
             logo
               ? ` <img 
              style="width: 100%;height:100%;" 
              src="${logo}" 
            />`
               : `<svg class="nvd-std-widget-logo" xmlns="http://www.w3.org/2000/svg" width="40" height="45" fill="${icon_color}" viewBox="0 0 55 65"><path fill="${icon_color}" d="m32.079 42.638 14.735-8.78v4.844L28.143 49.3V24.17l27.25-15.946V37.39s-.639 4.082-1.716 6.46c-1.056 2.33-1.97 3.505-3.633 5.45-2.217 2.592-3.952 3.578-6.661 5.651-5.578 4.268-15.341 9.386-15.341 9.386v-4.743s8.177-4.614 12.919-8.276c2.368-1.83 3.95-2.636 5.853-4.945 1.252-1.52 1.925-2.441 2.725-4.24.782-1.755 1.312-4.743 1.312-4.743V15.994L32.08 27.096v15.542Z"></path><path fill="${icon_color}" d="M28.041 64.334V59.59l-11.505-6.964s-4.458-2.775-6.661-5.248C8.52 45.86 7.859 44.904 6.847 43.14c-.887-1.544-1.475-2.412-1.918-4.137-.608-2.367 0-6.258 0-6.258L50.75 5.797l-4.743-2.523L.79 29.918s-.753 5.617 0 9.084c.538 2.474 1.098 3.837 2.321 6.055 1.264 2.292 2.235 3.452 4.038 5.35 2.28 2.4 6.66 5.247 6.66 5.247l14.231 8.68ZM32.889.652.896 19.525v5.248L41.468.653h-8.58ZM13.713.752.896 8.322v6.156L24.108.752H13.713Z"></path></svg>`
           }
          </div>
            <div id="nvd-standard-widget-content" style="display: flex; flex-direction: column; text-align: left;">
            <h3 class="nvd-std-widget-title" style="
              margin:0px;
              font-size: ${title_font_size || '16px'};
              font-weight: ${title_font_weight || 600};
              color: ${title_color};
            ">${title?.replace('Navidium', '')}</h3>
            <div class="nvd-secondary-content">
            <p class="nvd-std-widget-subtitle" style="
              margin:0px;
              font-size: ${subtitle_font_size || '12px'};
              font-weight: ${subtitle_font_weight || 400};
              color: ${subtitle_color};
            ">
              ${subtitle} 
              <span class="nvd-std-widget-price" style="color: ${protection_amount_color};">
              ${nvdFormatMoney(protectionPrice)}</span>
            </p>
            ${
              learn_more
                ? `<a class="nvd-std-widget-learn-more" style="font-size:12px; display:flex;align-items:center;gap:3px; color:${learn_more_color}; text-decoration:underline;" href='${learn_more_destination}'>${learn_more_text}</a>`
                : ''
            }
            </div>
          </div>
        </div>
      </div>
        <button ${
          isDisabled ? 'disabled' : ''
        } id="nvd-with-checkout-btn" style="
          background-color: ${button_background_color};
          color: ${button_color};
          border-radius: 4px;
          padding: 12px;
          font-size:${button_font_size || '14px'};
          font-weight:${button_font_weight || 600};
          border: none;
          cursor: pointer;
          width:100%;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 5px;
        ">
        ${img ? 
          `<img style="width: 17px;height:18px;" src="${img}" />` : ''
        }
          <span id="nvd-subtotal">${buttonLabel}</span>
        </button>
        ${
          is_secondary_button_enable
            ? ` <button ${
                isDisabled ? 'disabled' : ''
              } id="nvd-without-checkout-btn" style="
          background-color: ${secondary_button_background_color};
          color: ${secondary_button_color};
          border-radius: 4px;
          padding: 12px;
          font-size:${secondary_button_font_size || '14px'};
          font-weight:${secondary_button_font_weight || 400};
          border: none;
          cursor: pointer;
          text-decoration:underline;
        ">
          <span id="nvd-subtotal">${secondaryButtonLabel}</span>
        </button>`
            : ''
        }
        <p class="nvd-custom-description">By opting out of protection, we're not liable for damaged, lost or stolen packages.</p>
      </div>
    `
}
function standardWidgetTemplateTwo(
  protectionPrice,
  cartTotal,
  storeAgreeCheckbox
) {
  const {
    general: {
      section_content: { logo },
      section_style: {
        background_color,
        border_color,
        icon_color,
        icon_background_color,
        protection_amount_color
      }
    },
    heading: {
      section_content: {
        title,
        subtitle,
        learn_more,
        learn_more_text,
        learn_more_destination
      },
      section_style: {
        title_color,
        subtitle_color,
        learn_more_color,
        title_font_size,
        title_font_weight,
        subtitle_font_size,
        subtitle_font_weight
      }
    },
    cta_button: {
      section_content: {
        img,
        button_text,
        is_secondary_button_enable,
        secondary_button_text,
        show_subtotal,
        show_additional_checkout_button
      },
      section_style: {
        button_color,
        button_background_color,
        secondary_button_color,
        secondary_button_background_color,
        button_font_size,
        secondary_button_font_size,
        button_font_weight,
        secondary_button_font_weight
      }
    }
  } = nvdConsentConfig?.standard_widget

  const cartSubTotal = cartTotal * 100
  const isDisabled = storeAgreeCheckbox && !storeAgreeCheckbox?.checked
  const totalWithProtection = cartSubTotal + protectionPrice
  const nvdTotal = nvdFormatMoney(totalWithProtection)
  const buttonLabel = button_text.replaceAll('{price}', nvdTotal)
  const secondaryButtonLabel = secondary_button_text?.replaceAll(
    '{price}',
    nvdFormatMoney(cartSubTotal)
  )

  return `
      <div class="nvd-standard-widget-t-two" id="nvd-standard-widget-container" style="
        background-color: ${background_color};
        max-width: 375px;
        padding: 8px;
        border: 2px solid ${border_color};
        display: flex;
        gap:4px;
        flex-direction: column;
        justify-content: center;
      ">
      ${ show_subtotal ? 
        `<div class="nvd-subtotal-area" style="display:flex;justify-content:space-between;align-items:center">
            <p style="margin:0;">Subtotal:</p>
            <p class="nvd-subtotal-price" style="margin:0;">${nvdFormatMoney(cartSubTotal)}</p>
          </div>` : ''
      }
      <div class="nvd-main-content-area">
          <button ${
            isDisabled ? 'disabled' : ''
          } id="nvd-with-checkout-btn" style="
          background-color: ${button_background_color};
          color: ${button_color};
          border-radius: 4px;
          padding: 12px;
          font-size:${button_font_size || '14px'};
          border: none;
          cursor: pointer;
          width:100%;
          font-weight:${button_font_weight || 800};
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 5px;
        ">
        ${img ? 
          `<img style="width: 17px;height:18px;" src="${img}" />` : ''
        }
          <span id="nvd-subtotal">${buttonLabel}</span>
        </button>
        <div id="nvd-standard-widget-contents"  style="
          display: flex;
          align-items: start;
          margin-top:5px;
          gap:5px;
        " class="nvd-widget-contents">
          <div id="nvd-standard-widget-logo" style="max-width: 60px; max-height:60px; background-color:${icon_background_color};padding:10px;border-radius:8px;">
           ${
             logo
               ? ` <img 
              style="width: 100%;height:100%;" 
              src="${logo}" 
            />`
               : `<svg class="nvd-std-widget-logo" xmlns="http://www.w3.org/2000/svg" width="40" height="45" fill="${icon_color}" viewBox="0 0 55 65"><path fill="${icon_color}" d="m32.079 42.638 14.735-8.78v4.844L28.143 49.3V24.17l27.25-15.946V37.39s-.639 4.082-1.716 6.46c-1.056 2.33-1.97 3.505-3.633 5.45-2.217 2.592-3.952 3.578-6.661 5.651-5.578 4.268-15.341 9.386-15.341 9.386v-4.743s8.177-4.614 12.919-8.276c2.368-1.83 3.95-2.636 5.853-4.945 1.252-1.52 1.925-2.441 2.725-4.24.782-1.755 1.312-4.743 1.312-4.743V15.994L32.08 27.096v15.542Z"></path><path fill="${icon_color}" d="M28.041 64.334V59.59l-11.505-6.964s-4.458-2.775-6.661-5.248C8.52 45.86 7.859 44.904 6.847 43.14c-.887-1.544-1.475-2.412-1.918-4.137-.608-2.367 0-6.258 0-6.258L50.75 5.797l-4.743-2.523L.79 29.918s-.753 5.617 0 9.084c.538 2.474 1.098 3.837 2.321 6.055 1.264 2.292 2.235 3.452 4.038 5.35 2.28 2.4 6.66 5.247 6.66 5.247l14.231 8.68ZM32.889.652.896 19.525v5.248L41.468.653h-8.58ZM13.713.752.896 8.322v6.156L24.108.752H13.713Z"></path></svg>`
           }
          </div>
            <div id="nvd-standard-widget-content" style="display: flex; flex-direction: column; text-align: left;">
            <p class="nvd-title" style="
              margin:0px;
              font-size: ${title_font_size || '12px'};
              font-weight: ${title_font_weight || 600};
              color: ${title_color};
              line-height: normal;
            ">${title?.replace('Navidium', '')}  <span style="color: ${protection_amount_color};">
              ${nvdFormatMoney(protectionPrice)}</span></p>

            <div class="nvd-secondary-content">
            <p class="nvd-std-widget-subtitle" style="
              margin:0px;
              font-size: ${subtitle_font_size || '12px'};
              font-weight: ${subtitle_font_weight || 400};
              color: ${subtitle_color};
              line-height: normal;
            ">
              ${subtitle} 
            </p>
            ${
              learn_more
                ? `<a class="nvd-learn-more" style="font-size:12px; font-weight:500; display:flex;align-items:center;gap:3px; color:${learn_more_color};text-decoration:underline;" href='${learn_more_destination}'> <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-miterlimit="10" stroke-width="32" d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"></path><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M220 220h32v116"></path><path fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M208 340h88"></path><path d="M248 130a26 26 0 1026 26 26 26 0 00-26-26z"></path></svg><span>${learn_more_text}</span></a>`
                : ''
            }
            </div>
          </div>
        </div>
    
      </div>
        ${
          is_secondary_button_enable
            ? ` <button ${
                isDisabled ? 'disabled' : ''
              } id="nvd-without-checkout-btn" style="
          background-color: ${secondary_button_background_color};
          color: ${secondary_button_color};
          border-radius: 4px;
          padding: 12px;
          font-size:${secondary_button_font_size || '14px'};
          font-weight:${secondary_button_font_weight || 400};
          border: none;
          cursor: pointer;
          text-decoration:underline;
        ">
          <span id="nvd-subtotal">${secondaryButtonLabel}</span>
        </button>`
            : ''
        }
      </div>
    `
}
function standardWidgetTemplateThree(
  protectionPrice,
  cartTotal,
  storeAgreeCheckbox
) {
  const {
    general: {
      section_content: { logo , hide_logo},
      section_style: {
        background_color,
        border_color,
        icon_color,
        icon_background_color,
        protection_amount_color
      }
    },
    heading: {
      section_content: {
        title,
        subtitle,
        learn_more,
        learn_more_text,
        learn_more_destination
      },
      section_style: {
        title_color,
        subtitle_color,
        learn_more_color,
        title_font_size,
        title_font_weight,
        subtitle_font_size,
        subtitle_font_weight
      }
    },
    cta_button: {
      section_content: {
        img,
        button_text,
        is_secondary_button_enable,
        secondary_button_text,
        show_subtotal,
        show_additional_checkout_button
      },
      section_style: {
        button_color,
        button_background_color,
        secondary_button_color,
        secondary_button_background_color,
        button_font_size,
        secondary_button_font_size,
        button_font_weight,
        secondary_button_font_weight
      }
    }
  } = nvdConsentConfig?.standard_widget

  const cartSubTotal = cartTotal * 100
  const isDisabled = storeAgreeCheckbox && !storeAgreeCheckbox?.checked
  const totalWithProtection = cartSubTotal + protectionPrice
  const nvdTotal = nvdFormatMoney(totalWithProtection)
  const buttonLabel = button_text.replaceAll('{price}', nvdTotal)
  const secondaryButtonLabel = secondary_button_text?.replaceAll(
    '{price}',
    nvdFormatMoney(cartSubTotal)
  )

  return `
      <div class="nvd-standard-widget-t-three" id="nvd-standard-widget-container" style="
        background-color: ${background_color};
        max-width: 420px;
        padding: 8px;
        border: 2px solid ${border_color};
        display: flex;
        gap:4px;
        flex-direction: column;
        justify-content: center;
      ">
        ${ show_subtotal ? 
          `<div class="nvd-subtotal-area" style="display:flex;justify-content:space-between;align-items:center">
              <p style="margin:0;">Subtotal:</p>
              <p class="nvd-subtotal-price" style="margin:0;">${nvdFormatMoney(cartSubTotal)}</p>
            </div>` : ''
        }
        <div class="nvd-main-content-area" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            " >
            <div id="nvd-standard-widget-contents"  class="nvd-widget-contents" style="
              display: flex;
              align-items: start;
              gap: 10px;
            ">
              ${!hide_logo ? 
                `<div id="nvd-standard-widget-logo" style="background-color:${icon_background_color};margin-bottom: 7px; height: 14px;">
                ${
                  logo
                    ? ` <img 
                    style="width: 16px;height:16px;" 
                    src="${logo}" 
                  />`
                    : `<svg class="nvd-std-widget-logo" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="${icon_color}" viewBox="0 0 55 65"><path fill="${icon_color}" d="m32.079 42.638 14.735-8.78v4.844L28.143 49.3V24.17l27.25-15.946V37.39s-.639 4.082-1.716 6.46c-1.056 2.33-1.97 3.505-3.633 5.45-2.217 2.592-3.952 3.578-6.661 5.651-5.578 4.268-15.341 9.386-15.341 9.386v-4.743s8.177-4.614 12.919-8.276c2.368-1.83 3.95-2.636 5.853-4.945 1.252-1.52 1.925-2.441 2.725-4.24.782-1.755 1.312-4.743 1.312-4.743V15.994L32.08 27.096v15.542Z"></path><path fill="${icon_color}" d="M28.041 64.334V59.59l-11.505-6.964s-4.458-2.775-6.661-5.248C8.52 45.86 7.859 44.904 6.847 43.14c-.887-1.544-1.475-2.412-1.918-4.137-.608-2.367 0-6.258 0-6.258L50.75 5.797l-4.743-2.523L.79 29.918s-.753 5.617 0 9.084c.538 2.474 1.098 3.837 2.321 6.055 1.264 2.292 2.235 3.452 4.038 5.35 2.28 2.4 6.66 5.247 6.66 5.247l14.231 8.68ZM32.889.652.896 19.525v5.248L41.468.653h-8.58ZM13.713.752.896 8.322v6.156L24.108.752H13.713Z"></path></svg>`
                }
                </div>` 
                : 
                ""
              }
                <div id="nvd-standard-widget-content" style="text-align: left;">
                    <p class="nvd-title" style="
                      margin:0px;
                      font-size: ${title_font_size || '12px'};
                      font-weight: ${title_font_weight || 600};
                      color: ${title_color};
                      line-height: 20px;
                    ">${title?.replace('Navidium', '')}  
                    <span style="color: ${protection_amount_color};">
                      ${nvdFormatMoney(protectionPrice)}
                    </span>
                    </p>
                </div>
            </div>
              <div class="nvd-secondary-content">
                    ${
                      learn_more
                        ? `<a class="nvd-learn-more" style="font-size:12px; font-weight:500; display:flex;align-items:center;gap:3px; color:${learn_more_color};text-decoration:underline;" href='${learn_more_destination}'> <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" stroke-miterlimit="10" stroke-width="32" d="M248 64C146.39 64 64 146.39 64 248s82.39 184 184 184 184-82.39 184-184S349.61 64 248 64z"></path><path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M220 220h32v116"></path><path fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M208 340h88"></path><path d="M248 130a26 26 0 1026 26 26 26 0 00-26-26z"></path></svg><span>${learn_more_text}</span></a>`
                        : ''
                    }
                  </div>
          </div>
            <button ${
                isDisabled ? 'disabled' : ''
              } id="nvd-with-checkout-btn" style="
              background-color: ${button_background_color};
              color: ${button_color};
              border-radius: 4px;
              padding: 12px;
              font-size:${button_font_size || '14px'};
              border: none;
              cursor: pointer;
              width:100%;
              font-weight:${button_font_weight || 800};
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 5px;
            ">
            ${img ? 
              `<img style="width: 17px;height:18px;" src="${img}" />` : ''
            }
              <span id="nvd-subtotal">${buttonLabel}</span>
            </button>
            ${
              is_secondary_button_enable
                ? ` <button ${
                    isDisabled ? 'disabled' : ''
                  } id="nvd-without-checkout-btn" style="
              background-color: ${secondary_button_background_color};
              color: ${secondary_button_color};
              border-radius: 4px;
              padding: 6px;
              font-size:${secondary_button_font_size || '14px'};
              font-weight:${secondary_button_font_weight || 400};
              border: none;
              cursor: pointer;
              text-decoration:underline;
            ">
              <span id="nvd-subtotal">${secondaryButtonLabel}</span>
            </button>`
                : ''
            }
            <p class="nvd-std-widget-subtitle" style="
              margin:0px;
              text-align:center;
              font-size: ${subtitle_font_size || '12px'};
              font-weight: ${subtitle_font_weight || 400};
              color: ${subtitle_color};
              line-height: normal;
            ">
              ${subtitle} 
            </p>
      </div>
    `
}

function standardWidgetTemplateFour(
  protectionPrice,
  cartTotal,
  storeAgreeCheckbox
) {
  const {
    general: {
      section_style: {
        background_color,
        border_color,
        border_radius,
        protection_amount_color,
      },
    },
    heading: {
      section_content: {
        title,
        subtitle,
        learn_more,
        learn_more_text,
        learn_more_destination,
        hide_powered_by,
      },
      section_style: {
        title_color,
        subtitle_color,
        learn_more_color,
        title_font_size,
        title_font_weight,
        subtitle_font_size,
        subtitle_font_weight,
      },
    },
    cta_button: {
      section_content: {
        img,
        button_text,
        is_secondary_button_enable,
        secondary_button_text,
        show_subtotal,
        show_additional_checkout_button,
      },
      section_style: {
        button_color,
        button_background_color,
        secondary_button_color,
        secondary_button_background_color,
        button_font_size,
        secondary_button_font_size,
        button_font_weight,
        secondary_button_font_weight,
      },
    },
  } = nvdConsentConfig?.standard_widget;

  const cartSubTotal = cartTotal * 100;
  const isDisabled = storeAgreeCheckbox && !storeAgreeCheckbox?.checked;
  const totalWithProtection = cartSubTotal + protectionPrice;
  const nvdTotal = nvdFormatMoney(totalWithProtection);
  const buttonLabel = button_text.replaceAll("{price}", nvdTotal);
  const secondaryButtonLabel = secondary_button_text?.replaceAll(
    "{price}",
    nvdFormatMoney(cartSubTotal)
  );

  return `
    <div 
      id="nvd-standard-widget-container" 
      class="nvd-standard-widget-t-four" 
      style="
        background-color: ${background_color};
        max-width: 480px;
        padding: 12px;
        border: 2px solid ${border_color};
        border-radius: ${border_radius};
        display: flex;
        flex-direction: column;
        gap: 8px;
        justify-content: center;
        text-align: center;
        font-family: Arial, sans-serif;
      "
    >
    ${
      show_subtotal
        ? `<div class="nvd-subtotal-area" style="display:flex;justify-content:space-between;align-items:center">
              <p style="margin:0;">Subtotal:</p>
              <p class="nvd-subtotal-price" style="margin:0;">${nvdFormatMoney(
                cartSubTotal
              )}</p>
            </div>`
        : ""
    }
      <div class="nvd-title" style="color: ${title_color}; font-size: ${title_font_size || '11px'}; font-weight: ${title_font_weight || 600}; display: flex; justify-content: center; align-items: center; gap: 6px;">
        <span>${title?.replace('Navidium', '')} 
        <span style="color: ${protection_amount_color};">
            ${nvdFormatMoney(protectionPrice)}
        </span></span>
        ${
          learn_more
            ? `<a class="nvd-learn-more" href="${learn_more_destination}" target="_blank" style="text-decoration: none;">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" >
          <path d="M10 9.16667H10.8333V15H9.16667V10.8333C8.70667 10.8333 8.33333 10.46 8.33333 10C8.33333 9.54 8.70667 9.16667 9.16667 9.16667H10ZM10 20C4.4775 20 0 15.5225 0 10C0 4.4775 4.4775 0 10 0C15.5225 0 20 4.4775 20 10C20 15.5225 15.5225 20 10 20ZM10 18.3333C14.6025 18.3333 18.3333 14.6025 18.3333 10C18.3333 5.3975 14.6025 1.66667 10 1.66667C5.3975 1.66667 1.66667 5.3975 1.66667 10C1.66667 14.6025 5.3975 18.3333 10 18.3333ZM8.75 6.25C8.75 5.56 9.305 5 10 5C10.69 5 11.25 5.555 11.25 6.25C11.25 6.94 10.695 7.5 10 7.5C9.31 7.5 8.75 6.945 8.75 6.25Z" fill="#fff">
          </path></svg>
          </a>`
            : ""
        }
      </div>

      <button ${isDisabled ? "disabled" : ""} id="nvd-with-checkout-btn"
        style="
          font-weight: ${button_font_weight};
          font-size: ${button_font_size};
          background-color: ${button_background_color};
          color: ${button_color};
          padding: 8px 16px;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 5px;
          width: 100%
        "
      >
        ${img ? 
          `<img style="width: 17px;height:18px;" src="${img}" />`
              : `<svg class="nvd-button-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="18px"
                height="18px"
                fill="none"
                {...props}
              >
                <path
                  stroke="#fff"
                  strokeLinejoin="round"
                  d="M8.468 7.875V6.75a1.5 1.5 0 1 1 3 0v1.125M9.405 12h1.125c.88 0 1.32 0 1.623-.232.078-.06.147-.13.207-.208.233-.303.233-.743.233-1.623s0-1.319-.233-1.622a1.127 1.127 0 0 0-.207-.207c-.303-.233-.743-.233-1.623-.233H9.405c-.88 0-1.32 0-1.622.232-.078.06-.148.13-.208.208-.232.303-.232.743-.232 1.623s0 1.319.232 1.622c.06.078.13.148.208.207.303.233.743.233 1.622.233Z"
                />
                <path
                  stroke="#fff"
                  strokeLinecap="round"
                  d="M16.718 8.387V6.21c0-1.23 0-1.845-.303-2.246s-.989-.596-2.36-.986a18.432 18.432 0 0 1-2.42-.88c-.9-.398-1.35-.598-1.667-.598-.318 0-.768.2-1.667.599-.66.292-1.485.613-2.421.88-1.37.389-2.056.584-2.36.985-.302.401-.302 1.016-.302 2.246v2.177c0 4.22 3.797 6.75 5.695 7.753.456.24.683.36 1.055.36.371 0 .599-.12 1.054-.36 1.899-1.002 5.696-3.534 5.696-7.753Z"
                />
              </svg>`
        }
        <span id="nvd-subtotal">${buttonLabel}</span>
      </button>

      ${
        !hide_powered_by
          ? `<div class="nvd-powered-by"
          style="
            padding: 4px 8px;
            border-radius: 40px;
            width: fit-content;
            margin-left: auto;
            background: white;
            display: flex;
            align-items: center;
            gap: 5px;
          "
        >
          <span style="font-size: 11px;">Powered by </span>
          <img src="https://d10pwglna6up6p.cloudfront.net/navidium-widgets/assets/icons/powered.png" alt="navidium-icon" height="12px">
        </div>`
          : ""
      }

       ${
         is_secondary_button_enable
           ? ` <button ${
               isDisabled ? "disabled" : ""
             } id="nvd-without-checkout-btn" style="
        background-color: ${secondary_button_background_color};
        color: ${secondary_button_color};
        border-radius: 4px;
        padding: 6px;
        font-size:${secondary_button_font_size || "14px"};
        font-weight:${secondary_button_font_weight || 400};
        border: none;
        cursor: pointer;
        text-decoration:underline;
      ">
        <span id="nvd-subtotal">${secondaryButtonLabel}</span>
      </button>`
           : ""
       }
    </div>
  `;
}

// for terms and agree checkbox
const changeNvdCheckoutBtnStatus = (checked) => {
  const checkoutBtn = document.querySelectorAll(
    '#nvd-with-checkout-btn, #nvd-without-checkout-btn'
  )
  checkoutBtn.forEach((elm) => {
    if (!checked) {
      elm.setAttribute('disabled', 'true')
    } else {
      elm.removeAttribute('disabled')
    }
  })
}
window.addEventListener('change', (e) => {
  const checkboxes = window.nvdStoreCheckbox
    ? document.querySelectorAll(window.nvdStoreCheckbox)
    : null
  if (!checkboxes) return
  checkboxes.forEach((cb) => {
    if (cb === e.target) {
      changeNvdCheckoutBtnStatus(e.target.checked)
    }
  })
})

if(window.nvdInstantLoad){
  nvdPrefetch().then(()=>nvd_init)
  setTimeout(() => {
    nvd_init()
  }, 500)
}
window.addEventListener('DOMContentLoaded', () => {
  nvdPrefetch().then(()=>nvd_init)
  new Promise((resolve) => {
    setTimeout(() => {
      nvd_init()
      resolve()
    }, 2000)
  }).then(() => {
    nvdUpdateLiveCart(null)
  })
})
if (document.readyState === 'complete') {
  nvd_init()
} else {
  window.addEventListener('load', () => {
    nvd_init()
  })
}

window.addEventListener(
  'click',
  (ev) => {
    const navidiumTriggers = Array.from(
      document.querySelectorAll(nvdWidgetHelpers?.click_triggers)
    )
    const elm = ev.target
    // setTimeout(injectNvdToCart, 500)
    if (navidiumTriggers.includes(elm)) {
      useConsole('navidium triggered slide cart')
      setTimeout(() => {
        nvd_init()
          .then(() => {
            nvdUpdateLiveCart()
          })
          .catch((err) => {})
      }, 2000)
    }
  },
  true
)

const nvdUpdateProtection = async (currentVariant, newVariant) => {
  try {
    const updates = {
      [currentVariant]: 0,
      [newVariant]: 1
    }
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;',
        Accept: 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    return res.json()
  } catch (error) {
    useConsole('Error on updating', error)
  }
}
const nvdAddProtectionController = () => {
  const variantId = localStorage.getItem('nvdVariant')
  const addedVariant = localStorage.getItem('cart_protection')
  if (addedVariant === variantId) {
    nvdRedirectToCheckout()
  } else if (addedVariant && addedVariant !== variantId) {
    nvdUpdateProtection(addedVariant, variantId).then(() => {
      nvdRedirectToCheckout()
    })
  } else if (!addedVariant) {
    addProtection(variantId).then(() => {
      nvdRedirectToCheckout()
    })
  }
}
// for store checkout button (if consent agree)
const nvdStoreCheckoutButtons = window.nvdStoreCheckoutButtons || nvdWidgetHelpers.store_checkout_button + ", [name='checkout']"
$(document).one(`click`, nvdStoreCheckoutButtons, function (e) {
  useConsole('Clicked on Store checkout button')
  if(document
    .querySelector('#shippingProtectionCheckBox')){
      useConsole('Our input found, Preventing now')
      e.preventDefault()
      let checked = document
        .querySelector('#shippingProtectionCheckBox')
        ?.hasAttribute('checked')
      if (localStorage.getItem('nvdVariant') != null) {
        let variantId = localStorage.getItem('nvdVariant')
        if (!checked) {
          if (document.querySelector('#nvd-reminder-modal')?.innerHTML?.length > 0) {
            nvdReminderPopupOpen()
          } else {
            window.location.href = window.location.origin + '/checkout'
          }
        } else {
          nvdAddProtectionController()
        }
      } else {
        window.location.href = window.location.origin + '/checkout'
      }
    }
})
  

$(document).one(`click`, '#nvd-with-checkout-btn', function (e) {
  try {
    useConsole('Clicked on our checkout button with protection')
  e.preventDefault()
  e.target.innerHTML="<span class='nvd-cta-loader'></span>"
  if (localStorage.getItem('nvdVariant') != null) {
    nvdAddProtectionController()
  } else {
    nvdRedirectToCheckout()
  }
  } catch (error) {
    location.href="/checkout"
  }
})

$(document).one(`click`, '#nvd-without-checkout-btn', function (e) {
  try {
    useConsole('Clicked on our checkout button without protection')
  e.preventDefault()
  e.target.innerHTML="<span class='nvd-cta-loader'></span>"
  if (document.querySelector('#nvd-reminder-modal')?.innerHTML?.length > 0) {
    nvdReminderPopupOpen()
  } else {
    const cartProtectionVariant = localStorage.getItem('cart_protection')
    if (cartProtectionVariant) {
      removeNavidium(cartProtectionVariant).finally(() => {
        nvdRedirectToCheckout()
      })
    } else {
      nvdRedirectToCheckout()
    }
  }
  } catch (error) {
    location.href="/checkout"
  }
})

// Tracking Cart Changes
class NvdCartWatcher {
  init() {
    this.emitCartChanges().then(() => {
      this.observeCartChanges()
    })
  }

  async fetchCart() {
    const response = await fetch(`/cart.js?t=${Date.now()}`, {
      cache: 'no-cache',
    })
    return response.json()
  }

  storeCart(cart) {
    localStorage.setItem('nvdCart', JSON.stringify(cart))
  }

  storedCart() {
    return JSON.parse(localStorage.getItem('nvdCart')) || { items: [] }
  }

  findCartChanges(oldCart, newCart) {
    const onlyInLeft = (l, r) =>
      l.filter((li) => !r.some((ri) => li.key == ri.key))
    let result = {
      added: onlyInLeft(newCart.items, oldCart.items),
      removed: onlyInLeft(oldCart.items, newCart.items)
    }

    oldCart.items.forEach((oldItem) => {
      const newItem = newCart.items.find(
        (item) =>
          !item.handle.includes('shipping-protection') &&
          item.key == oldItem.key &&
          item.quantity != oldItem.quantity
      )
      if (!newItem) return
      let quantity = newItem.quantity - oldItem.quantity
      let item = { ...newItem }
      item.quantity = Math.abs(quantity)
      quantity > 0 ? result.added.push(item) : result.removed.push(item)
    })

    return result
  }

  async emitCartChanges() {
    const newCart = await this.fetchCart()
    const oldCart = this.storedCart()
    const changes = this.findCartChanges(oldCart, newCart)

    const event = new CustomEvent('nvd_cart_changed', { detail: changes })
    window.dispatchEvent(event)

    this.storeCart(newCart)
  }

  observeCartChanges() {
    const cartObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        const isValidRequestType = ['xmlhttprequest', 'fetch'].includes(
          entry.initiatorType
        )
        const isCartChangeRequest = /\/cart\//.test(entry.name)
        if (isValidRequestType && isCartChangeRequest) {
          this.emitCartChanges()
        }
      })
    })
    cartObserver.observe({ entryTypes: ['resource'] })
  }
}

const myNvdCartWatcher = new NvdCartWatcher()
myNvdCartWatcher.init()

window.addEventListener('nvd_cart_changed', (e) => {
  if (e.detail?.added?.length != 0 || e?.detail?.removed?.length != 0) {
    useConsole('Cart changed::', e.detail)
    getNvdCartDetails().then((cart) => {
      if(cart && cart?.items?.length){
        window.nvdCartItems = cart.items
      }
    }).finally(()=>{
      nvd_init()
    })
  }
})
if (window.nvdStopRedirect && !window.nvdStopJSTrigger) {
  window.addEventListener(
    'click',
    (e) => {
      const trigger = Array.from(
        document.querySelectorAll(
          '#nvd-with-checkout-btn, #nvd-with-checkout-btn *, #nvd-without-checkout-btn, #nvd-without-checkout-btn *'
        )
      )
      if (trigger.includes(e.target)) {
        e.preventDefault()
        e.target.innerHTML="<span class='nvd-cta-loader'></span>"
        useConsole("PREVENRING FROM REDIRECTING")
        nvdRedirectToCheckout()
      }
    },
    true
  )
}
   window.addEventListener("pageshow", function(event) {
    if (event.persisted) {
      nvd_init()
    }
  });